import styled from 'styled-components'

import { _XS_Medium, _XS_Normal, mainColors } from '@avantstay/backoffice-core'

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
`

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 240px;
  padding: 4px 8px;
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 8px;
  background: ${mainColors.neutralExtraLight};
`

export const Thumb = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
`

export const TypeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: ${mainColors.neutralLight};
  color: ${mainColors.neutralExtraDark};
  flex-shrink: 0;
`

export const ChipName = styled.span`
  ${_XS_Medium}
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${mainColors.neutralExtremelyDark2};
`

export const ChipSize = styled.span`
  ${_XS_Normal}
  white-space: nowrap;
  color: ${mainColors.neutralExtraDark};
`

export const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${mainColors.neutralExtraDark};
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${mainColors.neutralMedium};
    color: ${mainColors.neutralExtremelyDark2};
  }
`
